<template>
  <div class="content weChat">
    <div class="header">微信配置</div>
    <div class="width900">
      <el-form
        size="small"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="200px"
        class="demo-ruleForm"
      >
        <el-form-item label="服务器url验证链接">
          <div class="hint">{{ ruleForm.checkurl }}</div>
        </el-form-item>
        <el-form-item label="微信公众号appid" prop="appid">
          <el-input v-model="ruleForm.appid"></el-input>
        </el-form-item>
        <el-form-item label="	微信公众号应用密钥" prop="appsecret">
          <el-input v-model="ruleForm.appsecret"></el-input>
        </el-form-item>
        <el-form-item label="	微信公众号名称" prop="wx_name">
          <el-input v-model="ruleForm.wx_name"></el-input>
        </el-form-item>
        <el-form-item label="微信服务器验证token" prop="wx_token">
          <el-input v-model="ruleForm.wx_token"></el-input>
        </el-form-item>
        <el-form-item label="商户号" >
          <el-input v-model="ruleForm.pay_machid"></el-input>
        </el-form-item>
        <!-- <el-form-item label="服务配置文件" prop="verify_file">
          <el-upload
            class="upload-demo"
            action
            :limit="1"
            :file-list="fileList"
            :on-exceed="handleExceed"
            :http-request="uploadSectionFile"
            :on-remove="handleRemove"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item> -->
        <!-- <el-form-item label="第三方授权">
          <el-button type="primary" @click="showEmpower=true">授权</el-button>
          <span class="sq_text" v-if="wx_done">已授权</span>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">配置</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog :visible.sync="showEmpower" @close="showEmpower=false" width="500px">
      <el-form label-width="80px" style="margin-right:20px">
        <el-form-item label="链接地址">
          <el-input v-model="linkUrl" clearable></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align:center">
        <el-button type="primary" @click="saveLink">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  wechat_setConfig,
  wechat_getConfig,
  uploadVerify,
} from "@/api/configuration";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  data() {
    return {
      filesData: {},
      fileList: [
        {
          name: "",
          url: ""
        }
      ],
      ruleForm: {
        token: "",
        appid: "",
        appsecret: "",
        wx_name: "",
        wx_token: "",
        pay_machid: "",
        verify_file: ""
      },
      wx_done: false, //是否已授权
      showEmpower: false, //显示授权窗口
      linkUrl: "", //二维码链接地址
      rules: {
        appid: [
          { required: true, message: "请输入微信公众号appid", trigger: "blur" }
        ],
        appsecret: [
          {
            required: true,
            message: "请输入微信公众号应用密钥",
            trigger: "blur"
          }
        ],
        wx_name: [
          {
            required: true,
            message: "请输入微信公众号名称（微信公众号配置必须）",
            trigger: "blur"
          }
        ],
        wx_token: [
          {
            required: true,
            message: "请输入微信服务器验证token（微信公众号配置必须）",
            trigger: "blur"
          }
        ],
        verify_file: [
          { required: true, message: "请上传文件", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    // 自定义上传文件
    uploadSectionFile(content) {
      let data = new FormData();
      data.append("token", this.token);
      data.append("image", content.file);
      uploadVerify(data).then(res => {
        this.ruleForm.verify_file = res.data;
      });
    },
    // 删除文件
    handleRemove() {
      this.ruleForm.verify_file = "";
    },
    // 超出提醒
    handleExceed() {
      console.log(this.fileList);
      this.$message.warning("请删除后上传");
    },
    // 获取配置
    getConfig() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      wechat_getConfig(data).then(res => {
        console.log(res, this.ruleForm);
        this.ruleForm = res.data;
        this.ruleForm.token = this.token;
        this.ruleForm.app_id = this.app_id;
        if (res.data.verify_file) {
          this.fileList[0].name = res.data.verify_file.split("/")[3];
          this.fileList[0].url = res.data.verify_file;
        } else {
          this.fileList = [];
        }
      });
    },
    // 提交配置
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          wechat_setConfig(this.ruleForm).then(res => {
            console.log(this.fileList);
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.getConfig();
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 保存二维码链接
    saveLink(){
      var data = {
        token: this.token,
        app_id: this.app_id,
        callback: this.linkUrl
      }
      // QrCodeUrl(data).then(res=>{
      //   if(res.code == 200){
      //     console.log(res.data)
      //     this.$message({
      //       type: "success",
      //       message: res.msg
      //     })
      //   }else{
      //     this.$message({
      //       type: "error",
      //       message: res.msg
      //     })
      //   }
      // })
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: 100%;
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.weChat {
  padding: 10px 25px;
  background-color: #fff;
  .header {
    border-bottom: 0;
    background-color: #f8f8f8;
    position: relative;
    padding-left: 24px;
    margin-bottom: 15px;
    padding: 10px 15px;
  }
  .header:after {
    content: "";
    position: absolute;
    width: 4px;
    height: 16px;
    background: #1ab394;
    border-radius: 30%;
    top: 50%;
    left: 10px;
    margin-top: -8px;
  }
  .width900 {
    width: 900px;
  }
  .hint {
    font-size: 20px;
    color: #909399;
  }
  .issue {
    padding: 10px 0 30px;
  }
  .el-form-item {
    margin-bottom: 40px !important;
  }
  .sq_text{
    margin-left: 15px;
    color: #999;
  }
}
</style>
